import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Button, Field, Input, Loader } from '@itds/elements/index.js';

import H1 from '@brokerage/components/H1';

import { Api } from '@brokerage/utils/Api';

const Show = () => {
  const params = useParams();

  const [data, setData] = useState({});
  const [website, setWebsite] = useState({});
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error_message, setErrorMessage] = useState();
  const [success_message, setSuccessMessage] = useState();

  useEffect(() => {
    return () => {
      setErrorMessage(null);
      setSuccessMessage(null);
    };
  }, []);
  useEffect(() => {
    loadWebsite();
  }, []);

  const loadWebsite = () => {
    setLoading(true);
    Api.loadWebsite(params.id).then(({ data }) => {
      setWebsite(data);

      setData({
        agency_id: data.agency_id,
        is_archived: data.is_archived,
        member_id: data.member_id,
        name: data.name,
        stripe_plan_id: data.stripe_plan_id,
        stripe_subscription_id: data.stripe_subscription_id,
        weebly_site_id: data.weebly_site_id,
        weebly_user_id: data.weebly_user_id
      });

      setLoading(false);
    });
  };

  const _handleChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleArchiveToggle = () => {
    setData({ ...data, is_archived: !data.is_archived });
    updateWebsite({ is_archived: !data.is_archived });
  };

  const handleKeyUp = name => {
    const removedErrors = errors;

    removedErrors.splice([name]);
    setErrors([...errors, removedErrors]);
  };

  const updateWebsite = data => {
    window.scrollTo(0, 0);

    setLoading(true);

    Api.updateWebsite(params.id, data)
      .then(response => {
        const { status } = response;

        if (status === 200) {
          setLoading(false);
          loadWebsite();
          setSuccessMessage('Website updated successfully');
        }
      })
      .catch(error => {
        if (error) {
          setErrorMessage('Unable to update Website');
        }
      });
  };

  const handleSave = e => {
    e.preventDefault();
    const errors = [];

    if (!data.name) {
      errors.push('name');
    }
    if (!data.weebly_user_id) {
      errors.push('weebly_user_id');
    }
    if (!data.weebly_site_id) {
      errors.push('weebly_site_id');
    }

    if (errors.length) {
      setErrors(errors);
    } else {
      setErrors([]);
      updateWebsite(data);
    }
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      {error_message ? <Alert type='error'>{error_message}</Alert> : null}
      {success_message ? <Alert type='success'>{success_message}</Alert> : null}
      <H1>Editing: {website.name}</H1>

      <div style={{ width: '50%' }}>
        <Field label='Name'>
          <Input
            invalid={errors.includes('name')}
            onChange={_handleChange.bind(null, 'name')}
            onKeyUp={handleKeyUp.bind(null, 'name')}
            required={true}
            value={data.name}
          />
        </Field>
        <Field label='Weebly User ID'>
          <Input
            invalid={errors.includes('weebly_user_id')}
            onChange={_handleChange.bind(null, 'weebly_user_id')}
            onKeyUp={handleKeyUp.bind(null, 'weebly_user_id')}
            required={true}
            value={data.weebly_user_id}
          />
        </Field>
        <Field label='Weebly Site ID'>
          <Input
            invalid={errors.includes('weebly_site_id')}
            onChange={_handleChange.bind(null, 'weebly_site_id')}
            onKeyUp={handleKeyUp.bind(null, 'weebly_site_id')}
            required={true}
            value={data.weebly_site_id}
          />
        </Field>
        <div style={{ display: 'flex', marginTop: 40 }}>
          <Button color={data.is_archived ? null : 'RED'} onClick={handleArchiveToggle}>
            {data.is_archived ? 'Unarchive' : 'Archive'}
          </Button>
          {data.is_archived ? null : (
            <Button onClick={handleSave} style={{ marginLeft: 5 }}>
              Save
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default Show;
